'use strict';

export default angular
  .module('maestro.services.virtual-paginator', [])

  .factory('VirtualPaginator', function() {
    const DEFAULT_PAGE_SIZE = 30;

    function VirtualPaginator(getItemsFunc, pageSize) {
      pageSize = pageSize || DEFAULT_PAGE_SIZE;
      let items;
      let currentPageItems;
      let currentPage;
      let totalItems;
      let totalPages;
      let sortBy;
      let sortByReverse;
      this.reload = loadItems;

      function ctor() {
        loadItems();
      }

      function loadItems() {
        if (getItemsFunc && typeof getItemsFunc === 'function') {
          getItemsFunc()
            .then(function(_items) {
              if (!_items) {
                items = void 0;
                totalItems = void 0;
                currentPage = void 0;
                totalPages = void 0;
                currentPageItems = void 0;
                return;
              }
              items = _items;
              sort();
              totalItems = items.length;
              currentPage = 1;
              totalPages = Math.ceil(totalItems / pageSize);
              currentPageItems = items.slice((currentPage - 1) * pageSize, currentPage * pageSize);
            }, function() {
              items = void 0;
              totalItems = void 0;
              currentPage = void 0;
              totalPages = void 0;
              currentPageItems = void 0;
            });
        } else if (getItemsFunc && Array.isArray(getItemsFunc)) {
          this.items = getItemsFunc;
        }
      }

      Object.defineProperty(this, 'items', {
        get: function() { return items; },
        set: function(value) {
          if (!value) {
            items = void 0;
            totalItems = void 0;
            currentPage = void 0;
            totalPages = void 0;
            currentPageItems = void 0;
            return;
          }
          items = value;
          sort();
          totalItems = items.length;
          totalPages = Math.ceil(totalItems / pageSize);
          currentPage = currentPage && currentPage > totalPages ? totalPages : (currentPage || 1);
          currentPageItems = items.slice((currentPage - 1) * pageSize, currentPage * pageSize);
        }
      });

      Object.defineProperty(this, 'currentPageItems', {
        get: function() { return currentPageItems; }
      });

      Object.defineProperty(this, 'currentPage', {
        get: function() { return currentPage; },
        set: function(value) {
          if (!items) {
            return;
          }
          if (!value || value <= 0) {
            currentPage = 1;
          } else if (value > totalPages) {
            currentPage = totalPages;
          } else {
            currentPage = value;
          }
          currentPageItems = items.slice((currentPage - 1) * pageSize, currentPage * pageSize);
        }
      });

      Object.defineProperty(this, 'totalItems', {
        get: function() { return totalItems; }
      });

      Object.defineProperty(this, 'totalPages', {
        get: function() { return totalPages; }
      });

      Object.defineProperty(this, 'pageSize', {
        get: function() { return pageSize; },
        set: function(value) {
          if (value <= 0) {
            pageSize = DEFAULT_PAGE_SIZE;
            return;
          }
          pageSize = value;
          if (items) {
            totalPages = Math.ceil(totalItems / pageSize);
            currentPage = currentPage > totalPages ? totalPages : currentPage;
            currentPageItems = items.slice((currentPage - 1) * pageSize, currentPage * pageSize);
          }
        }
      });

      Object.defineProperty(this, 'sortBy', {
        get: function() { return sortBy; },
        set: function(value) {
          sortBy = value;
          if (items) {
            sort();
            currentPageItems = items.slice((currentPage - 1) * pageSize, currentPage * pageSize);
          }
        }
      });

      Object.defineProperty(this, 'sortByReverse', {
        get: function() { return sortByReverse; },
        set: function(value) {
          sortByReverse = !!value;
          if (items) {
            sort();
            currentPageItems = items.slice((currentPage - 1) * pageSize, currentPage * pageSize);
          }
        }
      });

      function sort() {
        if (!sortBy) {
          return;
        }
        items = items.sort(function(a, b) {
          if (a[sortBy] > b[sortBy]) {
            return sortByReverse ? -1 : 1;
          }
          if (a[sortBy] < b[sortBy]) {
            return sortByReverse ? 1 : -1;
          }
          return 0;
        });
      }

      ctor();
    }

    return VirtualPaginator;
  })

  .name;
